import Component from '../site/Component';

/**
 * Component for elements that swap positions in the DOM between breakpoints
 */
export default class Swappable extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    // Vars
    this.placeholder = this.createPlaceholder();
    this.location = this.element.dataset.swapLocation;
    this.method = this.element.dataset.swapMethod;
    this.breakpointNames = Object.keys(this.utils.breakpoints.breakpoints);
    this.initSwap = this.initSwap.bind(this);

    const swapMin = this.element.dataset.swapMin || false;
    const swapMax = this.element.dataset.swapMax || false;

    // Generate media query
    if (
      swapMin &&
      swapMax &&
      (this.breakpointNames.indexOf(swapMax) >
        this.breakpointNames.indexOf(swapMin))
    ) {
      // Breakpoint is exclusive (min is higher than max)
      this.query = this.utils.breakpoints.generateMedia(swapMin, false) ||
        this.utils.breakpoints.generateMedia(false, swapMax);
    } else {
      // breakpoint is inclusive (min is lower than max)
      this.query = this.utils.breakpoints
        .generateMedia(swapMin, swapMax);
    }

    // Inits
    if (this.query) {
      this.initSwap(this.query);
      this.query.addListener(this.initSwap);
    }
  }

  /**
   * Creates a placeholder element to save this.element's original location.
   * @return {DOMelement} Placeholder element.
   */
  createPlaceholder() {
    // Create element
    const placeholder = document.createElement('div');
    // Add class for debugging
    placeholder.classList.add('swap-placeholder');
    // Insert into DOM
    this.element.parentNode
      .insertBefore(placeholder, this.element);
    // Save reference to node
    return placeholder;
  }

  /**
   * Perform the swapping action.
   * @param  {MediaQueryList} query
   * @return {void}
   */
  initSwap(query) {
    // Check the breakpoints provided to see if the element should move
    const isSwapped = this.element.classList.contains('swapped');

    if (query.matches && ! isSwapped) {
      this.swapToNewLocation();
    } else if (! query.matches && isSwapped) {
      this.swapToFormerLocation();
    }
  }

  /**
   * Move this.element to its target location.
   * @return {void}
   */
  swapToNewLocation() {
    const target = this.location ?
      document.querySelector(this.location) :
      false;

    // Fail if it cannot find the target.
    if (! target) {
      // eslint-disable-next-line no-console
      console.error(
        `Swap location ${this.location} does not exist.`,
        this.element
       );
      return;
    }

    switch (this.method) {
      // Placed the swapped element after the location element
      case 'after':
        if (target.nextSibling) {
          target.parentElement
            .insertBefore(this.element, target.nextSibling);
        } else {
          target.parentElement
            .appendChild(this.element);
        }
        break;

      // Place the swapped element before the location element
      case 'before':
        target.parentElement
          .insertBefore(this.element, target);
        break;

      // Add the swapped element as a child of the location element, at the beginning
      case 'prepend':
        if (target.children.length) {
          target.insertBefore(this.element, target.children[0]);
        } else {
          target.appendChild(this.element);
        }
        break;

      // Add the swapped element as a child of the location element, at the end
      case 'append':
      default:
        target.appendChild(this.element);
        break;
    }

    this.element.classList.add('swapped');
  }

  /**
   * Return this.element to its place before the placeholder
   * @return {void}
   */
  swapToFormerLocation() {
    this.placeholder.parentNode
      .insertBefore(this.element, this.placeholder);
    this.element.classList.remove('swapped');
  }
}
